import "./sidebar.scss";
import { FunctionComponent } from "react";

import {
    House, User, Wallet2, ChartCandlestick, DoorOpen, LayoutDashboardIcon,
    WalletCards, Package, History,
} from "lucide-react";
import { LucideIcon } from "lucide-react";
import { useAppDispatch, useAppSelector } from "../../features/helpers";
import { setSidebarStatus } from "../../store/SidebarSlice";
import { NavLink, useNavigate } from "react-router-dom";
import { setLoggedStatus, setLoggedType } from "../../store/AuthSlice";
import { clearSession } from "../../utils/session";

import { RouteKey } from "../../auth/permissions";
import { useRole } from "../../auth/useRole";

interface MenuItem {
    label: string;
    icon: LucideIcon;
    to: string;
    requireKey: RouteKey;
}

const MENU: MenuItem[] = [
    { label: "Dashboard",          icon: House,             to: "/",          requireKey: "home" },
    { label: "Carteiras",          icon: Wallet2,           to: "/wallets",   requireKey: "wallets" },
    { label: "Depositos",          icon: ChartCandlestick,  to: "/depositos", requireKey: "client-deposits-self" },
    { label: "Contas das Empresas", icon: WalletCards,      to: "/accounts",  requireKey: "user-accounts" },
    { label: "Entregas",           icon: Package,           to: "/depositos", requireKey: "supplier-deliveries" },
    { label: "Historico",          icon: History,           to: "/wallets",   requireKey: "supplier-history" },
    { label: "Perfil",             icon: User,              to: "/perfil",    requireKey: "profile" },
];

const ClientSidebar: FunctionComponent = () => {

    const dispatch  = useAppDispatch();
    const navigate  = useNavigate();
    const statusBar = useAppSelector((state) => state.sidebar.sidebarStatus);
    const { can }   = useRole();

    const openMenu = () => dispatch(setSidebarStatus(!statusBar));

    const logout = () => {
        clearSession();
        dispatch(setLoggedStatus(false));
        dispatch(setLoggedType(""));
        navigate("/");
    };

    const hideOrShowMenu = () => {
        if (window.innerWidth < 768) {
            dispatch(setSidebarStatus(false))
        }
    }

    const visibleItems = MENU.filter((m) => can(m.requireKey));

    return (
        <div className={`sidebar-wrapper ${statusBar ? "active" : ""}`}>
            <h1 onClick={openMenu}>
                <LayoutDashboardIcon size={24} className="icon" /> Menu
            </h1>
            <ul className="list">
                {visibleItems.map((item) => {
                    const Icon = item.icon;
                    return (
                        <li key={`${item.to}-${item.requireKey}`}>
                            <NavLink to={item.to} className={({ isActive }) => isActive ? "active" : ""} onClick={hideOrShowMenu}>
                                <Icon size={20} /> {item.label}
                            </NavLink>
                        </li>
                    );
                })}
            </ul>

            <p onClick={logout}>
                <DoorOpen size={20} /> <span>Sair</span>
            </p>
        </div>
    );
};

export default ClientSidebar;
